export class ClinicContentBlockType {
  key: string = ''
  name: string = ''
  is_standard: boolean = false
}
